"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.percentage = exports.average = exports.sum = exports.lessThan = exports.greaterThan = exports.equals = exports.round = exports.divide = exports.multiply = exports.subtract = exports.add = void 0;
const libConfig_1 = __importDefault(require("./libConfig"));
const wait_1 = __importDefault(require("./wait"));
const apiOrderToAppOrder_1 = __importDefault(require("./apiOrderToAppOrder"));
const appBatchToApiBatch_1 = __importDefault(require("./appBatchToApiBatch"));
const appPaymentToApiPayment_1 = __importDefault(require("./appPaymentToApiPayment"));
const appPaymentsToApiPayments_1 = __importDefault(require("./appPaymentsToApiPayments"));
const fixPrecision_1 = __importDefault(require("./fixPrecision"));
const calculateLocalOrder_1 = __importDefault(require("./calculateLocalOrder"));
const calculateLocalBatchItem_1 = __importDefault(require("./calculateLocalBatchItem"));
const formatSummary_1 = __importDefault(require("./formatSummary"));
const toUtcFormat_1 = __importDefault(require("./toUtcFormat"));
const getFormatBatchItemStatus_1 = __importDefault(require("./getFormatBatchItemStatus"));
const getFormatBatchItemStatusWithSet_1 = __importDefault(require("./getFormatBatchItemStatusWithSet"));
const groupBatchItem_1 = __importDefault(require("./groupBatchItem"));
const formatBatchItemStatus_1 = __importDefault(require("./formatBatchItemStatus"));
const getRoundNumber_1 = __importDefault(require("./getRoundNumber"));
const addNumberWithRounding_1 = __importDefault(require("./addNumberWithRounding"));
const getDisplayRoundNumber_1 = __importDefault(require("./getDisplayRoundNumber"));
const appOrderToApiOrder_1 = __importDefault(require("./appOrderToApiOrder"));
const adjustNumber_1 = __importDefault(require("./adjustNumber"));
const getDisplayStatusKey_1 = __importDefault(require("./getDisplayStatusKey"));
const setDeliveryTypeMenuPrice_1 = __importDefault(require("./setDeliveryTypeMenuPrice"));
const getComboList_1 = __importDefault(require("./getComboList"));
const getItemDataId_1 = __importDefault(require("./getItemDataId"));
const shortCode_1 = __importDefault(require("./shortCode"));
const Logger_1 = __importDefault(require("./Logger"));
const precisionMath_1 = __importDefault(require("./precisionMath"));
const locale_1 = __importStar(require("./locale"));
// 導出 precisionMath 的各個函數，方便直接使用
var precisionMath_2 = require("./precisionMath");
Object.defineProperty(exports, "add", { enumerable: true, get: function () { return precisionMath_2.add; } });
Object.defineProperty(exports, "subtract", { enumerable: true, get: function () { return precisionMath_2.subtract; } });
Object.defineProperty(exports, "multiply", { enumerable: true, get: function () { return precisionMath_2.multiply; } });
Object.defineProperty(exports, "divide", { enumerable: true, get: function () { return precisionMath_2.divide; } });
Object.defineProperty(exports, "round", { enumerable: true, get: function () { return precisionMath_2.round; } });
Object.defineProperty(exports, "equals", { enumerable: true, get: function () { return precisionMath_2.equals; } });
Object.defineProperty(exports, "greaterThan", { enumerable: true, get: function () { return precisionMath_2.greaterThan; } });
Object.defineProperty(exports, "lessThan", { enumerable: true, get: function () { return precisionMath_2.lessThan; } });
Object.defineProperty(exports, "sum", { enumerable: true, get: function () { return precisionMath_2.sum; } });
Object.defineProperty(exports, "average", { enumerable: true, get: function () { return precisionMath_2.average; } });
Object.defineProperty(exports, "percentage", { enumerable: true, get: function () { return precisionMath_2.percentage; } });
exports.default = {
    libConfig: libConfig_1.default,
    wait: wait_1.default,
    addNumberWithRounding: addNumberWithRounding_1.default,
    calculateLocalOrder: calculateLocalOrder_1.default,
    calculateLocalBatchItem: calculateLocalBatchItem_1.default,
    apiOrderToAppOrder: apiOrderToAppOrder_1.default,
    appBatchToApiBatch: appBatchToApiBatch_1.default,
    appPaymentToApiPayment: appPaymentToApiPayment_1.default,
    appPaymentToApiPayments: appPaymentsToApiPayments_1.default,
    groupBatchItem: groupBatchItem_1.default,
    fixPrecision: fixPrecision_1.default,
    formatSummary: formatSummary_1.default,
    getFormatBatchItemStatus: getFormatBatchItemStatus_1.default,
    getFormatBatchItemStatusWithSet: getFormatBatchItemStatusWithSet_1.default,
    formatBatchItemStatus: formatBatchItemStatus_1.default,
    getItemDataId: getItemDataId_1.default,
    getRoundNumber: getRoundNumber_1.default,
    getDisplayStatusKey: getDisplayStatusKey_1.default,
    setDeliveryTypeMenuPrice: setDeliveryTypeMenuPrice_1.default,
    getDisplayRoundNumber: getDisplayRoundNumber_1.default,
    appOrderToApiOrder: appOrderToApiOrder_1.default,
    adjustNumber: adjustNumber_1.default,
    toUtcFormat: toUtcFormat_1.default,
    getComboList: getComboList_1.default,
    shortCode: shortCode_1.default,
    Logger: Logger_1.default,
    precisionMath: precisionMath_1.default,
    createLocaleHelper: locale_1.default,
    getParsedPhoneNumber: locale_1.getParsedPhoneNumber,
    formatPhoneNumber: locale_1.formatPhoneNumber,
    phoneIsValid: locale_1.phoneIsValid,
    removeCountryCode: locale_1.removeCountryCode,
};
//# sourceMappingURL=index.js.map